import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectIsMortgageAvailable = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('ipoteka')(jsonQuery),
);
